<template>
  <v-app :dark="dark">
    <not-auth-toolbar></not-auth-toolbar>
    <v-content>
      <v-container justify-center fill-height>
        <v-layout align-center justify-center column>
          <v-icon color="error" size="54">{{$vuetify.icons.error}}</v-icon>
<!--          <div class="display-2 grey&#45;&#45;text mt-5 mb-3" style="font-size: 25px">因系统升级，该功能暂无法使用，维护人员正在处理中，预计24小时内恢复。</div>-->
          <div class="display-2 grey--text mt-5 mb-3" style="font-size: 20px">{{ $route.query.text || '暂无授权' }}</div>
        </v-layout>
      </v-container>
    </v-content>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import AppFooter from '../APP/Footer/appFooter'
import NotAuthToolbar from '../APP/Toolbar/notAuthToolbar'
export default {
  name: 'AccessDeny',
  components: {NotAuthToolbar, AppFooter},
  computed: {
    dark () {
      return this.$store.getters.dark
    }
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
  }
}
</script>

<style scoped>

</style>
